export var globalConfig: any =
{
    leaderboardUrl: 'https://recycling.ppp-leaderboards.com'
};



// WEBPACK FOOTER //
// ./src/ts/config/Config.ts